import "../scss/main.scss";

// Importa Bootstrap JS components
import { Modal, Button, Collapse, Dropdown, ScrollSpy } from "bootstrap";

window.bsModal = Modal;

import Swiper from "swiper";
import { Grid, Navigation, Scrollbar, Thumbs, Virtual, Autoplay } from "swiper/modules";


// Importa Feather Icons
import feather from "feather-icons";

// Impost @iconfu/svg-inject
import "@iconfu/svg-inject";

// Importa altri moduli JS o CSS necessari qui
import { initNavigation } from "./module/navigation.js";
import { setupForms } from "./module/forms.js";
import { initHomeModule } from "./module/home.js";
import { initCategoryPage } from "./module/category.js";
import { initProductModule } from "./module/product.js";
import { initCataloguesModule } from "./module/catalogues.js";
import { initSpecialProjectModule } from "./module/special_project.js";
import { initAmbientePage } from "./module/ambiente.js";
import { togglePrices } from "./module/toggle_prices.js";


Swiper.use([Grid, Navigation, Scrollbar, Thumbs, Virtual, Autoplay]);

function initializeSwiper(selector, options, dinamicSlides = false) {
    // if (selector instanceof HTMLElement) {
    //     console.log('Init swiper: .' + selector.classList[1]);
    // } else {
    //     console.log('Init swiper: ' + selector);
    // }

    var slider = new Swiper(selector, options);

    if (dinamicSlides) {
        slider.slidesPerViewDynamic()
    }

    return slider;
}

function counterAnimation() {
    const counters = document.querySelectorAll('[data-counter]');
    if (counters.length === 0) return;

    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
    };

    const callback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const counter = entry.target;
                const targetValue = parseInt(counter.getAttribute('data-counter'), 10);
                let currentValue = 0;
                const increment = Math.ceil(targetValue / 100); // Incremento per animazione

                const updateCounter = () => {
                    currentValue += increment;
                    if (currentValue > targetValue) {
                        currentValue = targetValue;
                    }
                    counter.textContent = currentValue.toLocaleString(); // Formatta con separatore delle migliaia
                    if (currentValue < targetValue) {
                        requestAnimationFrame(updateCounter);
                    }
                };

                updateCounter();
                observer.unobserve(counter); // Ferma l'osservazione dopo l'animazione
            }
        });
    };

    const observer = new IntersectionObserver(callback, options);
    counters.forEach(counter => observer.observe(counter));
}

window.initializeSwiper = initializeSwiper;

// Inizializza Feather Icons
document.addEventListener("DOMContentLoaded", function () {
    // Altri setup del tema

    SVGInject(document.querySelectorAll("img.svginj"));
    feather.replace({ "stroke-width": 1, 'width': 24, 'height': 24 }); // Inizializza Feather Icons

    initNavigation();
    togglePrices();
    initHomeModule();
    initAmbientePage();
    setupForms();
    initCategoryPage();
    initProductModule();
    initCataloguesModule();
    initSpecialProjectModule();

    // 404 error selected products
    // Swiper prodotti correlati
    if (document.querySelectorAll('.selected-products-error-swiper').length > 0) {
        initializeSwiper('.selected-products-error-swiper', {
            slidesPerView: 2.15,
            spaceBetween: 20,
            loop: false,
            navigation: {
                enabled: true,
                nextEl: '.slider-button-next',
                prevEl: '.slider-button-prev',
                addIcons: false
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2.25,
                },
                992: {
                    slidesPerView: 3.35,
                },
                1400: {
                    slidesPerView: 4,
                },
                1700: {
                    slidesPerView: 5,
                },
                1920: {
                    slidesPerView: 6,
                }
            },
        });
    }

    counterAnimation();
});
